var $b9d08f9d50543ce2$exports = {};
$b9d08f9d50543ce2$exports = {
  "alert": "Br\u012Bdin\u0101jums",
  "dismiss": "Ner\u0101d\u012Bt"
};
export { $b9d08f9d50543ce2$exports as default };